function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "595.28px",
    viewBox: "0 0 330.43 397.728",
    enableBackground: "new 0 0 595.28 595.28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -132, -98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.771,242.053h46.499c5.705,0,10.331-4.631,10.331-10.332c0-5.709-4.626-10.334-10.331-10.334h-46.499 c-5.705,0-10.33,4.625-10.33,10.334C136.44,237.422,141.065,242.053,146.771,242.053z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.771,286.684h46.499c5.705,0,10.331-4.625,10.331-10.328c0-5.707-4.626-10.334-10.331-10.334h-46.499 c-5.705,0-10.33,4.627-10.33,10.334C136.44,282.059,141.065,286.684,146.771,286.684z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.771,331.324h46.499c5.705,0,10.331-4.621,10.331-10.334c0-5.707-4.626-10.328-10.331-10.328h-46.499 c-5.705,0-10.33,4.621-10.33,10.328C136.44,326.703,141.065,331.324,146.771,331.324z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.771,375.959h46.499c5.705,0,10.331-4.621,10.331-10.332c0-5.703-4.626-10.33-10.331-10.33h-46.499 c-5.705,0-10.33,4.627-10.33,10.33C136.44,371.338,141.065,375.959,146.771,375.959z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.255,102.404H196.722c-16.863,0-30.582,13.721-30.582,30.576v43.766h-19.369 c-5.705,0-10.33,4.631-10.33,10.338s4.625,10.338,10.33,10.338h46.499c5.705,0,10.331-4.631,10.331-10.338 s-4.626-10.338-10.331-10.338h-10.598V132.98c0-7.748,6.304-14.047,14.05-14.047h155.647v97.146c0,1.629,0.957,3.107,2.446,3.771 c1.485,0.672,3.23,0.396,4.443-0.695l19.629-17.559l18.514,17.482c0.783,0.748,1.803,1.131,2.838,1.131 c0.554,0,1.11-0.105,1.634-0.338c1.521-0.65,2.5-2.141,2.5-3.793v-97.146h23.882c7.749,0,14.053,6.299,14.053,14.047v329.316 c0,7.746-6.304,14.045-14.053,14.045H196.722c-7.746,0-14.05-6.299-14.05-14.045v-41.703h10.598 c5.705,0,10.331-4.621,10.331-10.332c0-5.703-4.626-10.328-10.331-10.328h-46.499c-5.705,0-10.33,4.625-10.33,10.328 c0,5.711,4.625,10.332,10.33,10.332h19.369v41.703c0,16.859,13.719,30.58,30.582,30.58h231.533 c16.866,0,30.585-13.721,30.585-30.58V132.98C458.84,116.125,445.121,102.404,428.255,102.404z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.105,348.473c3.426,0,6.199-2.773,6.199-6.197v-89.271c0-3.422-2.773-6.205-6.199-6.205H232.799 c-3.426,0-6.199,2.783-6.199,6.205v89.271c0,3.424,2.773,6.197,6.199,6.197H396.105z M238.998,259.197h150.908v76.881H238.998 V259.197z",
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.13,
    y: 274.285,
    width: 127.243,
    height: 23.359,
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.13,
    y: 309.312,
    width: 127.243,
    height: 11.678,
    style: {
      fill: "rgba(249, 249, 249, 0.43)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.78384148.svg";
export { ForwardRef as ReactComponent };